import { render, staticRenderFns } from "./BrokerStaffProfilePopUp.vue?vue&type=template&id=552bebdc&scoped=true&"
import script from "./BrokerStaffProfilePopUp.vue?vue&type=script&lang=js&"
export * from "./BrokerStaffProfilePopUp.vue?vue&type=script&lang=js&"
import style0 from "./BrokerStaffProfilePopUp.vue?vue&type=style&index=0&id=552bebdc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552bebdc",
  null
  
)

export default component.exports